import css from "styled-jsx/css";

export const componentStyles = css.global`
  .integrations-tab-content {
    .live-board-tab-wrapper {
      .responsive-hoc-component {
        .desktop-wrapper {
          .flexible-cards-grid-desktop-component {
            .flexible-cards-grid-desktop-component-inner {
              .grid-paragraph-with-image-component-wrapper {
                .top-layer {
                  .grid-paragraph-with-image {
                    .grid-paragraph-wrapper {
                      display: none;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
